import React from 'react'
import { Box, Typography } from '@mui/material'
import Win from './elements/Win'
import Lose from './elements/Lose'

const WinLoseRule = ({ simple, rule }) => {
  return (
    <Box className="win-lose">
      <Typography variant="body2" className="rule-line">
        <Win simple={simple} rule={rule} />
        <Lose simple={simple} rule={rule} />
      </Typography>
    </Box>
  )
}

export default WinLoseRule
